import React from "react";

function CheckConnectivityPasswordField({ value, onChange, disabled }) {

    return (
        <div className="oct-shared-popup__field">
            <label className="oct-shared-popup__label" htmlFor="password">
                Password <span className="oct-shared-popup__required-mark">*</span>
            </label>
            <input
                className="oct-shared-popup__input"
                id="password"
                value={value}
                type="password"
                autoComplete="off"
                disabled={disabled}
                placeholder="Enter password"
                onChange={event => onChange(event.target.value)}
            />
        </div>
    )

}

export default CheckConnectivityPasswordField;
